module.exports = __webpack_public_path__ + "img/1f9bf.fc02fb0.svg";